// Wrapper around the presentational PopoverView.
//
// The design system ships PopoverView (takes sheetPaddingBottomClassName as a
// prop, no app coupling). This wrapper supplies the anchored-ad padding so
// call-sites keep the original API.
import { type PopoverProps, Popover as PopoverView } from "./PopoverView";

export type { PopoverProps };

export const Popover = (props: PopoverProps) => (
  <PopoverView {...props} sheetPaddingBottomClassName="ad-gutter-pad" />
);

export default Popover;
